export default __webpack_public_path__ + "static/media/Ren.51715e3c.jpg";